import { makeStyles } from 'tss-react/mui';

import macOsScrollbar from 'main/theme/mac-os-scrollbar';

export default makeStyles({ name: 'CnaAffected' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 32,
        marginTop: 48
    },
    title: {
        fontSize: 24,
        fontWeight: 700
    },
    wrapper: {
        borderRadius: 16,
        backgroundColor: '#232323',
        padding: 8
    },
    code: {
        padding: 24,
        margin: 4,
        fontSize: 14,
        maxHeight: 400,
        ...macOsScrollbar({ color: '#535353', visible: 'always' }),
        ['& pre']: {
            margin: 0,
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
            ['& code']: {
                background: 'inherit'
            }
        }
    }
});
